import { Formik } from 'formik';
import {
  ApplicationProcessState,
  applicationStore,
  getProductPriceRequest,
  onAddApplicationRequest,
  resendCargoRequest,
  setPaymentInformationData,
} from 'Stores/CardApplication';
import { useLocalization } from 'Hooks';
import { UserState, userStore } from 'Stores/User';
import {
  close3DSecureModal,
  CreditCardTransactionsState,
  creditCardTransactionsStore,
  getBinListRequest,
  onGetMasterpassTokenRequest,
  setIsUserAddedCreditCardWithMasterpass,
  setUserTemporaryCreditCard,
} from 'Stores/CreditCardTransactions';
import { resetFormError, setFormError } from 'Stores/Form';
import { FC, useEffect, useState } from 'react';
import { fontSizes, gutters } from 'Theme/Variables';
import { useDispatch, useSelector } from 'react-redux';
import { AccountState, storeAccount } from 'Stores/Account';
import { townOtherListItem } from 'Models/GetTownListOtherModel';
import { adressTransactionTypes } from 'Views/UserAdressDetail/constant';
import { FormWrapper, Modal3DSecure, FormErrorWrapper } from 'Components';
import { Box, Typography, Button, FormHelperText } from '@material-ui/core';
import { InformationRow } from 'Views/CardApplicationsDetail/InformationRow';
import { formikGlobalConfig, formNames, getBinListReqBodyData } from 'Config';
import { getEnvironment, MasterPassRefType, MasterPassTokenEnum } from 'Utils';
import { masterPassListCardNormalize, masterPassPaymentNormalize } from 'Normalize';
import { PaymentStepSchema, paymentStepSchemaInitialValues } from 'Validations/PaymentStepSchema';
import {
  CardTransactionsState,
  setIsUserInCardApplicationProcess,
  setIsUserInUploadTLProcess,
  setIsUserInUploadSubscriptionProcess,
  setIsUserInAutomaticInstructionProcess,
  storeCardTransactions,
} from 'Stores/CardTransactions';
import ChoosePaymentMethod from 'Views/CardApplicationSteps/PaymentStep/ChoosePaymentMethod/ChoosePaymentMethod';
import 'Views/CardApplicationSteps/PaymentStep/PaymentStep.scss';
import sanitizeHtml from 'Utils/SanitizeHtml';
import { getCreditCardMask } from 'Utils/CreditCardUtils';

type PaymentStepProps = {};
const PaymentStep: FC<PaymentStepProps> = ({}) => {
  const dispatch = useDispatch();
  const {
    web_card_application_go_to_pay,
    web_card_application_amount,
    web_card_application_card_cost,
    web_card_application_shipping_cost,
    web_card_application_total_cost,
    web_free_shipping,
    web_application_payment_type_title,
    msg_web_upload_tl_add_debit_card_success,
    msg_web_upload_tl_add_debit_card_no_check,
    msg_web_zorunlu_alan,
  } = useLocalization();
  const {
    isShipping,
    activeApplicationData,
    applicationCard,
    productPriceResponse,
    activeCardShippingFee,
    activeUpStateShippingFee,
    cardApplicationStatus,
  }: ApplicationProcessState = useSelector(applicationStore);
  const { otherTownList }: AccountState = useSelector(storeAccount);
  const {
    is3DSecureModalOpen,
    vsPosBelbim3DsecureUrl,
    activePayment,
    creditCardList,
    activeSelectedCreditCard,
    macroMerchantId,
    userTempCreditCard,
    isUserAddedCreditCardWithMasterpass,
  }: CreditCardTransactionsState = useSelector(creditCardTransactionsStore);
  const { sessionToken, customerNumber }: UserState = useSelector(userStore);
  const [paymentMethodError, setPaymentMethodError] = useState<boolean>(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>(null);
  const { CustodyCustomerNumber }: CardTransactionsState = useSelector(storeCardTransactions);
  const SHIPPING_FEE =
    activeApplicationData?.AddressDetail?.CityCode === 34 ? activeCardShippingFee : activeUpStateShippingFee;
  // ⚠️ Opsiyonel zincir yalnız ÜST nesneyi koruyordu; `ProductPrice` undefined
  // geldiğinde `.toFixed(2)` render sırasında TypeError fırlatıyordu.
  const rawProductPrice = cardApplicationStatus === 6 ? 0 : productPriceResponse?.data?.ProductPrice;
  const hasProductPrice = typeof rawProductPrice === 'number' && !Number.isNaN(rawProductPrice);
  const productPrice = hasProductPrice ? (rawProductPrice as number).toFixed(2) : undefined;

  // Kargo ücreti BİLİNMİYOR ile ÜCRETSİZ ayrı şeyler. Ayrım yapılmadığı için
  // ücret `undefined` iken ekran "ücretsiz kargo" yazıp kök nedeni maskeliyordu.
  const shippingUnknown = isShipping && SHIPPING_FEE === undefined;

  const handleSubmit = (values: any) => {
    if (!selectedPaymentMethod) {
      setPaymentMethodError(true);
      return;
    }
    setPaymentMethodError(false);

    // ⚠️ Fiyat ya da (gerekliyse) kargo ücreti bilinmeden ödeme başlatılamaz.
    // Eskiden bu durumda saga içinde TypeError fırlıyor ve sessizce yutuluyordu.
    if (!hasProductPrice || shippingUnknown) {
      dispatch(setFormError({ errorCode: 'web_generic_error_desc', formName: formNames.paymentStep }));
      return;
    }

    if (cardApplicationStatus === 6) {
      const otherTownCode = otherTownList?.find(
        (item: townOtherListItem) => item.TownName === activeApplicationData?.AddressDetail?.TownCode
      );
      dispatch(setPaymentInformationData({ ...selectedPaymentMethod }));
      dispatch(
        resendCargoRequest({
          CustomerNumber: customerNumber,
          SessionToken: sessionToken,
          AddressType: '9',
          AddressDetail: activeApplicationData?.AddressDetail?.AddressDetail,
          CityCode: activeApplicationData?.AddressDetail?.CityCode,
          City: 'ISTANBUL',
          //City: activeApplicationData?.AddressDetail?.City,
          TownCode: otherTownCode?.TownId,
          District: activeApplicationData?.AddressDetail?.District,
          PostalCode: activeApplicationData?.AddressDetail?.PostalCode?.toString(),
          Street: activeApplicationData?.AddressDetail?.Street,
          ProcessType: adressTransactionTypes.updatedAdress,
        })
      );
    } else {
      dispatch(setPaymentInformationData({ ...selectedPaymentMethod }));
      dispatch(onAddApplicationRequest());
    }
  };

  const handlePaymentMethodSelect = (paymentMethod: any) => {
    setSelectedPaymentMethod(paymentMethod);
    setPaymentMethodError(false);
  };

  useEffect(() => {
    dispatch(resetFormError());

    // ⚠️ RAKİP AKIŞ BAYRAKLARI KAPATILIR.
    //
    // `isUserInUploadTLProcess` yalnızca kullanıcı o akışa GİRERKEN açılıyor ve onu
    // kapatan tek şey `setNormalizeCardTransactionStates`; kart başvurusu giriş
    // noktalarının hiçbiri onu dispatch etmiyor. Bayrak açık kalınca:
    //   • Token hatası `addBalanceToCard` formuna yazılıyor, bu ekran
    //     `formNames.paymentStep` dinlediği için hata EKRANDA GÖRÜNMÜYOR.
    //   • Kart Masterpass'e kaydedildikten sonra kullanıcı /add-balance-to-card'a
    //     yönlendiriliyor ve başvuru ödemesi hiç tamamlanmıyor.
    //
    // ⚠️ `setNormalizeCardTransactionStates()` KULLANILAMAZ: seçili kartı ve
    // `isUserInCardApplicationProcess` bayrağını da siliyor — kart ekleme ekranından
    // dönen kullanıcının kartı tam o alanlarda duruyor.
    dispatch(setIsUserInUploadTLProcess(false));
    dispatch(setIsUserInUploadSubscriptionProcess(false));
    dispatch(setIsUserInAutomaticInstructionProcess(false));

    dispatch(setIsUserInCardApplicationProcess(true));
    dispatch(
      getProductPriceRequest({
        ProductCode: applicationCard?.ProductCode!,
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
        CustodyCustomerNumber: CustodyCustomerNumber ? CustodyCustomerNumber : undefined,
      })
    );
    // Bin list request for credit card logos
    dispatch(
      getBinListRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
      } as getBinListReqBodyData)
    );
  }, []);

  // NOT: Kart listesi burada ÇEKİLMİYOR. Ödeme yöntemi listesi yalnızca seçim
  // dialog'unda görünüyor ve `useCreditCardList` ile o dialog açıldığında yükleniyor.

  // activeSelectedCreditCard değiştiğinde selectedPaymentMethod'u güncelle
  useEffect(() => {
    if (activeSelectedCreditCard) {
      setSelectedPaymentMethod(activeSelectedCreditCard);
    }
  }, [activeSelectedCreditCard]);

  // Component unmount olduğunda seçili kartı temizle
  useEffect(() => {
    return () => {
      setSelectedPaymentMethod(null);
      dispatch(resetFormError());
      dispatch(setUserTemporaryCreditCard(undefined));
      dispatch(setIsUserAddedCreditCardWithMasterpass(false));
    };
  }, []);

  return (
    <div id="paymentStep">
      <Typography variant="h3">
        <Box mb={gutters.regular} mt={gutters.big} fontWeight={600}>
          {web_application_payment_type_title}
        </Box>
      </Typography>
      <FormErrorWrapper formName={formNames.paymentStep}>
        <Formik
          initialValues={paymentStepSchemaInitialValues}
          validationSchema={PaymentStepSchema}
          onSubmit={handleSubmit}
          {...formikGlobalConfig}
        >
          {(formikProps) => {
            return (
              <FormWrapper onSubmit={formikProps.handleSubmit}>
                <ChoosePaymentMethod
                  selectedPaymentMethod={selectedPaymentMethod}
                  creditCardList={creditCardList}
                  onPaymentMethodSelect={handlePaymentMethodSelect}
                />
                {paymentMethodError && (
                  <FormHelperText error style={{ marginTop: 8, marginBottom: 16 }}>
                    {msg_web_zorunlu_alan}
                  </FormHelperText>
                )}
                {userTempCreditCard && (
                  <Typography variant="body1" className="loadBalance__tempCreditCard">
                    {isUserAddedCreditCardWithMasterpass
                      ? msg_web_upload_tl_add_debit_card_success
                      : msg_web_upload_tl_add_debit_card_no_check}
                  </Typography>
                )}
                <Typography variant="h3">
                  <Box mb={gutters.regular} mt={gutters.big} fontWeight={600}>
                    {web_card_application_amount}
                  </Box>
                </Typography>
                <InformationRow
                  topDivider
                  desc={hasProductPrice ? `${productPrice}` : '-'}
                  name={`${web_card_application_card_cost}`}
                />
                {shippingUnknown ? (
                  // Ücret bilinmiyor: "ücretsiz" yazmak yanıltıcı olurdu.
                  <InformationRow topDivider desc="-" name={web_card_application_shipping_cost} />
                ) : isShipping && SHIPPING_FEE && SHIPPING_FEE > 0 ? (
                  <InformationRow topDivider desc={`${SHIPPING_FEE}`} name={web_card_application_shipping_cost} />
                ) : (
                  <InformationRow topDivider desc={web_free_shipping} name={web_card_application_shipping_cost} />
                )}
                <Typography align="center">
                  <Box mt={gutters.big} fontSize={fontSizes.tiny}>
                    {web_card_application_total_cost}
                  </Box>
                </Typography>
                <Typography variant="h3" align="center">
                  <Box mb={gutters.big} fontSize={fontSizes.big} fontWeight={600}>
                    {!hasProductPrice || shippingUnknown
                      ? '-'
                      : isShipping
                      ? (Number(productPrice) + Number(SHIPPING_FEE || 0)).toFixed(2)
                      : Number(productPrice)}{' '}
                    TL
                  </Box>
                </Typography>
                <Button fullWidth variant="contained" color="secondary" type="submit" itemID="goToPayCardApplyBtnTest">
                  {web_card_application_go_to_pay}
                </Button>
              </FormWrapper>
            );
          }}
        </Formik>
      </FormErrorWrapper>
      {is3DSecureModalOpen && (
        <Modal3DSecure
          open={is3DSecureModalOpen}
          link={vsPosBelbim3DsecureUrl}
          paymentNo={activePayment}
          close={() => dispatch(close3DSecureModal())}
        />
      )}
    </div>
  );
};
export default PaymentStep;
